var _path, _g, _path2, _g2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 32,
    viewBox: "0 0 44 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_663_26864",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 0,
    width: 31,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8882 0L13.8125 2.07351H34.2525V25.2376L43.9105 15.5896H40.9764L36.3258 20.233V0H15.8882Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_663_26864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8882 0L13.8125 2.07351H34.2525V25.2376L43.9105 15.5896H40.9764L36.3258 20.233V0H15.8882Z",
    fill: "url(#paint0_linear_663_26864)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_663_26864",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 30,
    height: 26
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0898438 15.7848H3.02378L7.34168 11.4713V31.7092H27.7745L29.8504 29.6378H9.41762V6.46655L0.0898438 15.7848Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_663_26864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0898438 15.7848H3.02378L7.34168 11.4713V31.7092H27.7745L29.8504 29.6378H9.41762V6.46655L0.0898438 15.7848Z",
    fill: "url(#paint1_linear_663_26864)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5552 20.6063H19.1457V16.0375H23.5552C24.6666 16.0375 25.5659 17.0538 25.5659 18.3039C25.5659 19.5563 24.6666 20.6063 23.5552 20.6063ZM19.1457 11.1051H22.5233C23.2418 11.1051 23.8251 11.8035 23.8251 12.6656C23.8251 13.5255 23.2418 14.2241 22.5233 14.2241H19.1457V11.1051ZM25.2814 14.607C25.6695 14.0579 25.8988 13.3884 25.8988 12.6656C25.8988 10.8015 24.3869 9.2915 22.5233 9.2915H17.0723V22.4199H23.5552C25.8119 22.4199 27.6393 20.5581 27.6393 18.3039C27.6393 16.6687 26.6749 15.2572 25.2814 14.607Z",
    fill: "#5A5F72"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_663_26864",
    x1: 16.0205,
    y1: 2.35626,
    x2: 40.5205,
    y2: 19.8563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666CD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695663,
    stopColor: "#69D2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68AD65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_663_26864",
    x1: 8.521,
    y1: 6.85626,
    x2: 18.9146,
    y2: 9.31361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666CD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498537,
    stopColor: "#69D2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68AD65"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMini);
export default __webpack_public_path__ + "static/media/logo_mini.17675588.svg";
export { ForwardRef as ReactComponent };